import React from "react";
import styled from "styled-components";

export const TermLinkSpan = styled.span`
  padding: 2px 8px;
  background-color: ${(props) => props.termId ? props.theme.pallet.primaryLight : 'rgba(0, 255, 92, 1)'};
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  color: black;
  line-height: 1.5;

  &:hover {
    background-color: ${(props) => props.theme.pallet.primary};
    color: ${(props) => props.theme.pallet.white};
  }
`;

const TermLink = ({ termId, children, setCurrentTerm }) => {
  const handleClick = () => {
    termId && setCurrentTerm(termId);
  };
  return <TermLinkSpan termId={termId} onClick={() => handleClick()}>{children}</TermLinkSpan>;
};

export default TermLink;
